package ru.villawonka.app.presentation.screens.setup.compose.layout

import androidx.compose.foundation.Image
import androidx.compose.foundation.layout.ColumnScope
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.material.MaterialTheme
import androidx.compose.material.Text
import androidx.compose.runtime.Composable
import androidx.compose.ui.Modifier
import androidx.compose.ui.text.style.TextAlign
import androidx.compose.ui.unit.dp
import org.jetbrains.compose.resources.painterResource
import ru.villawonka.app.presentation.design.components.AppButton
import ru.villawonka.app.presentation.design.components.AppButtonSize
import ru.villawonka.app.presentation.design.components.AppButtonType
import ru.villawonka.app.presentation.design.extensions.AppSpacer
import ru.villawonka.app.presentation.design.theme.AppTextStyles
import ru.villawonka.app.presentation.design.theme.onSurfacePrimary
import ru.villawonka.app.presentation.design.theme.onSurfaceSecondary
import ru.villawonka.app.presentation.screens.setup.compose.SetupCallbacks
import ru.villawonka.app.resources.AppResources
import villawonka.composeapp.generated.resources.Res
import villawonka.composeapp.generated.resources.ic_congrats

@Composable
fun ColumnScope.SetupCongratsStepLayout(
    callbacks: SetupCallbacks,
) {
    Image(
        painter = painterResource(Res.drawable.ic_congrats),
        contentDescription = null,
    )
    AppSpacer(24.dp)
    Text(
        text = AppResources.strings.setupCongratsTitle,
        style = AppTextStyles.titleLargeBold,
        color = MaterialTheme.colors.onSurfacePrimary,
        textAlign = TextAlign.Center
    )
    AppSpacer(8.dp)
    Text(
        text = AppResources.strings.setupCongratsSubtitle,
        style = AppTextStyles.bodyMediumRegular,
        color = MaterialTheme.colors.onSurfaceSecondary,
        textAlign = TextAlign.Center
    )
    AppSpacer(40.dp)
    AppButton(
        text = AppResources.strings.setupContinueButton,
        type = AppButtonType.PRIMARY,
        size = AppButtonSize.LARGE,
        modifier = Modifier.fillMaxWidth()
    ) {
        callbacks.onContinueButtonClick()
    }
}